import { useEffect, useRef } from 'react';
import useCommonStore from 'store/useCommonStore';

/** 페이지 내 스크롤 관련 기능
 * 1. 페이지 내에서 쿼리스트링으로 페이지를 변경할 경우 페이지를 최상단으로 이동
 * 2. 스크롤이 멈추고 0.3초 후 전역 상태의 is_scroll을 false로 변경
 * */
const usePageScroll = () => {
	const { page, is_scroll, setIsScroll } = useCommonStore();

	const scroll_containter_ref = useRef<HTMLDivElement>(null);
	const scroll_handler_ref = useRef<any>(null);

	// const [is_started, setIsStarted];

	/** 페이지 변경 시 스크롤 최상단 */
	useEffect(() => {
		if (scroll_containter_ref.current === null) return;

		scroll_containter_ref.current.scroll({ top: 0, behavior: 'smooth' });
	}, [page, scroll_containter_ref]);

	// 스크롤이 멈췄을 때 0.3초후 전역상태에 반영
	useEffect(() => {
		if (is_scroll) scroll_handler_ref.current = setTimeout(() => setIsScroll(false), 300);
		// if (is_scroll) setIsScroll(false);
		return () => {
			if (scroll_handler_ref.current) clearTimeout(scroll_handler_ref.current);
		};
	}, [is_scroll]);

	// useEffect(() => {
	// 	window.addEventListener('scroll', handleScroll);
	// 	return () => {
	// 		window.removeEventListener('scroll', handleScroll); //clean up
	// 	};
	// }, []);

	// const handleScroll = () => {
	// 	// 스크롤이 Top에서 50px 이상 내려오면 true값을 useState에 넣어줌
	// 	if (window.scrollY >= 50) {
	// 		setIsScroll(true);
	// 		console.log(scroll);
	// 	} else {
	// 		// 스크롤이 50px 미만일경우 false를 넣어줌
	// 		setIsScroll(false);
	// 	}
	// };

	return scroll_containter_ref;
};

export default usePageScroll;
